import React from "react";
import image from "../../assets/Images/toukir-portfolio.jpg";
import wave from "../../assets/Images/stacked-waves-haikei.svg";
import resume from "../../assets/resume/Toukir Ahammed - Front-End Developer - Resume.pdf";
import BorderButton from "../BorderButton/BorderButton";
import SolidButton from "./../SolidButton/SolidButton";

const Header = () => {
  return (
    <header
      className="min-h-screen pt-16 lg:pt-28 text-cyan-600 font-medium overflow-hidden"
      id="header"
    >
      {/* <div
        className="bg-no-repeat bg-cover bg-w-full w-[calc(100vw-17px)] h-screen z-[10] opacity-30 absolute left-0 top-0 right-0 bottom-0 overflow-hidden"
        style={{ backgroundImage: `url(${wave})` }}
      ></div> */}
      <div className="text-center z-20">
        <h5 className="">Hi, my name is</h5>
        <h1 className="text-3xl md:text-5xl text-white mt-3">Toukir Ahammed</h1>
        <h5 className="text-lg md:text-xl mt-3">Front-End Developer</h5>

        <div className="w-72 h-72 mx-auto mt-12 ring-4 ring-cyan-300 ring-offset-4 ring-offset-gray-700 border-cyan-300 rounded-full overflow-hidden">
          <img src={image} className="w-full object-cover" alt="" />
        </div>

        <div className="mt-12">
          <BorderButton
            href={resume}
            className="text-lg md:text-xl inline-block h-full text-cyan-300 mr-4"
            target="_blank"
            rel="noreferrer"
          >
            View Resume
          </BorderButton>
          <SolidButton href="#contact" className="text-lg md:text-xl inline-block h-full ">
            Let's Talk
          </SolidButton>
        </div>
      </div>
    </header>
  );
};

export default Header;
